import { TextField } from "@mui/material";
import React, { useEffect, useRef } from "react";

export default function Input(props) {
  const {
    name,
    label,
    value,
    variant,
    size,
    type,
    onChange,
    inputProps,
    error = null,
    required = false,
    fullWidth = true,
    autoFocus,
    ...other
  } = props;
  const inputRef = useRef();

  // A number field on a phone should raise the numeric keypad, not the full QWERTY —
  // "decimal" rather than "numeric" because quantity and money both carry fils here.
  // A caller that passes its own inputMode still wins. What may be TYPED into the
  // field is not decided here: that is one app-wide rule, in utils/numericInput.js.
  const numberInputProps =
    type === "number" ? { inputMode: "decimal", ...inputProps } : inputProps;

  const handleFocus = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }, 10);
  };

  useEffect(() => {
    autoFocus && handleFocus();
    return () => {};
  }, [autoFocus]);

  return (
    <TextField
      variant={variant || "outlined"}
      size={size || "small"}
      label={label}
      name={name}
      data-field={name}
      type={type}
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      required={required}
      inputRef={inputRef}
      {...(numberInputProps && { inputProps: numberInputProps })}
      {...other}
      {...(error && { error: true, helperText: error })}
    />
  );
}
